<template>
  <div id="main" >
    <mt-header title="选择科室">
      <router-link to="/" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>
    </mt-header>

    <ul v-for="item in list" :key="item.bianhao">
        <mt-cell :title="item.name" is-link :to="'/submitappointment?bianhao='+item.bianhao"></mt-cell>
    </ul>

  </div>  
</template>

<script>
import Axios from 'axios'
import qs from 'qs';

export default {
  name: 'main',
  data () {
    return {
      msg: '这里是预约管理主页面',   
      vipname:'',
      wxopenid:'',
      wxbaseinfo:{
        openid:'',
        name:'',
        sex:'',
        idnumber:'',
        tel:'',
        status:''
      },
      list:[]
    }
  },
  created(){       
    // 1、从缓存读取openid    
    var temopenid="oym4F6GbgItOvrqilutyj4W-y5Rw";//localStorage.getItem('wxopenid');
    if(temopenid && temopenid!='undefined'){
        // 缓存存在
        this.wxbaseinfo.openid=temopenid;
        // 验证基本信息（是否有姓名）,无信息则完善基本信息
        this.checkInfo();   
    }
    else{
        // 缓存不存在，则跳转到授权页
        this.$router.push({path:'/authtest'});
    } 
  },
  methods:{
    // 验证用户信息
    checkInfo(){
      // 验证个人信息
      var api='http://localhost:6334/api/checkinfo';
      Axios.post(api,qs.stringify({
        'openid':this.wxbaseinfo.openid
        }),{emulateJSON: true},{
          headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}
        }).then(response=>{
              if(response.data.result=='false'){
                  // 出错了，则跳到出错处理页面
                  this.$router.push({path:'/err'});
              }
              else{
                if(response.data.data.name==null || response.data.data.name==''){
                    // 没有姓名信息跳转到完善基本信息
                    // this.$router.push({path:'/baseinfo'})
                    this.$router.push({name:'baseinfo',params:{'openid':response.data.data.openid}});
                }
                else{                    
                  // 信息完事，则正常显示 
                  this.vipname=response.data.data.name;
                  if(this.vipname){
                      this.wxbaseinfo.name=response.data.data.name;
                      this.wxbaseinfo.sex=response.data.data.sex;
                      this.wxbaseinfo.tel=response.data.data.tel;
                      this.wxbaseinfo.idnumber=response.data.data.idnumber;
                        // 加载科室列表
                        this.loadDepartmentlist();
                    }
                }
              }
      }),function(err){
          alert('appointment验证用户失败：' + err);
      }
    },
    // 加载科室列表
    loadDepartmentlist(){
        var api='http://localhost:6334/api/departmentlist';
        Axios.get(api).then((response)=>{            
            if(response.data.result=='false'){
                // 出错了，则跳到出错处理页面
                // this.$router.push({path:'/err'});
            }
            else{
                console.log(response);
                for(var i=0;i<response.data.data.length;i++)
                {
                    let temitem=response.data.data[i];
                    console.log('打印出来的数据项:' + temitem);
                    this.list.push(temitem);
                    console.log(temitem.name);
                }
            }
        }).catch((err)=>{
            alert('appointment验证用户失败：' + err);
        })
    },
    // 加载系统提示信息
    loadSystemTipInfo(){
        var api='http://localhost:6334/api/systeminfo?cla=servicetip';
        Axios.get(api).then((response)=>{            
            if(response.data.result=='false'){
                // 出错了，则跳到出错处理页面
                // this.$router.push({path:'/err'});
            }
            else{
                console.log(response);
                // 解码用 
                this.introduction=decodeURIComponent(response.data.data);
            }
        }).catch((err)=>{
            alert('appointment获取系统信息失败：' + err);
        })
    }
  }
}
</script>

<style>
#main,/*设置占满*/
html,
body {
  background-color: #f4f4f4;
  width: 100%;
  height: 100%;
  margin: 0;
}
ul{
    /* background-color: blue;
    text-align: left; */
    margin: 5px;
    padding:0px;
}
</style>


// WEBPACK FOOTER //
// src/components/appointmentonline.vue